import { render, staticRenderFns } from "./uploadDocumentModal.vue?vue&type=template&id=c7a17b16&"
import script from "./uploadDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./uploadDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports